<template>
  <!-- 选择询价商品 -->
  <el-dialog
    title="报价供应商"
    :visible.sync="supplierPriceVisible"
    width="800px"
    :before-close="closeSupplierDetailDia"
    :close-on-click-modal="false"
    append-to-body
    class="supplier-price"
  >
    <div class="supplier-name">
      <span>询价单名称:</span>
      <span>{{ params.enquiryName }}</span>
    </div>
    <div class="list-box">
      <el-table
        ref="tableData"
        v-loading="tabelLoading"
        max-height="445"
        :data="tableData"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column label="序号" width="60px">
          <template #default="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="supplierCompany" label="供应商名称" min-width="110" align="center"></el-table-column>
        <!-- <el-table-column
          prop="address"
          label="所在省市"
          min-width="100"
          align="center"
        >
        </el-table-column> -->
        <!-- <el-table-column prop="" label="是否报价" min-width="90" align="center">
          <template #default="scope">
            <span>
              {{ scope.row.offerStatus === 0 ? "否" : "是" }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column label="报价时间" min-width="130" align="center" prop="createTime">
          <!-- <template #default="scope">
            <span>
              {{ scope.row.offerStatus === 0 ? "" : scope.row.createTime }}
            </span>
          </template> -->
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-box">
      <e-pager
        :page-index="queryParams.pageNum"
        :total="total"
        :page-size="queryParams.pageSize"
        @change="handleCurrentChange"
      ></e-pager>
    </div>
    <div slot="footer">
      <div class="default-btn btn" @click="closeSupplierDetailDia">关闭</div>
    </div>
  </el-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/enquiry/index';
import ePager from '@/modules/projectA/components/common/e-pager';

export default {
  components: {
    ePager,
  },
  props: {
    supplierPriceVisible: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default() {
        return { supplierOfferId: -1, enquiryId: -1 };
      },
    },
  },
  data() {
    return {
      tabelLoading: false,
      total: 0,
      tableData: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  watch: {
    supplierPriceVisible(oldVal, newVal) {
      if (oldVal) {
        this.getCenterList({
          enquiryId: this.params.enquiryId,
          ...this.queryParams,
        });
      }
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getCenterList({
        ...this.queryParams,
        enquiryId: this.params.enquiryId,
      });
    },
    // 获取列表数据
    async getCenterList(params) {
      // 中间选商列表接口
      await Api.queryWaitSelectionOfferListByPage({
        ...params,
        offerStatusList: [1, 2, 3, 4, 6, 7],
      }).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          // this.formData =
          this.total = res.data.total;
          this.tableData = res.data?.records;
          // scope.row.offerStatus == 2
          this.tableData.forEach((item) => {
            if (item.offerStatus === 2) {
              this.currentRow = item.supplierCompanyId;
            }
          });
          console.log(res.data, '辅导辅导辅导');
        }
      });
    },
    closeSupplierDetailDia() {
      this.tableData = [];
      this.total = 0;
      this.listQuery = { ...this.cloneSelectProductsForm };
      this.$emit('update:supplierPriceVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination-box {
  margin: 20px auto;
}
.money-box {
  float: right;
  margin-top: 10px;
  .money {
    color: #f0250f;
  }
}
// 列表重置样式-开始
::v-deep .el-table__header .cell {
  .icon-question {
    height: 18px;
    width: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 50%;
    border: 1px solid #c5c5c5;
    color: #c5c5c5;
    display: inline-block;
    margin-left: 10px;
    &:hover {
      color: #fff;
      background-color: #c5c5c5;
    }
  }
}
::v-deep .el-table__row .cell {
  font-size: 12px;
  white-space: normal;
  padding-left: 6px;
  padding-right: 6px;
  .el-button {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 6px;
  }
  .edit-info {
    color: #c0c4cc;
  }
}
::v-deep .el-table--small td,
::v-deep .el-table--small th {
  padding: 6px 0;
}
::v-deep .el-table--small .el-table-column--selection {
  .cell {
    padding-left: 10px;
    padding-right: 10px;
    .el-checkbox__inner {
      border-radius: 0;
    }
  }
}
// 列表重置样式-结束

// dialog 重置样式开始
::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}
// dialog 重置样式结束

.supplier-price {
  .supplier-name {
    margin-bottom: 10px;
  }
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      /* .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      } */
    }
  }
  .list-box {
    .defalut-table-btn {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__body {
    padding: 10px;
  }

  ::v-deep .el-dialog__footer {
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }

    .default-btn {
      background: #fff;
      border: 1px solid #dcdfe6;
      &:hover {
        border-color: #2587ff;
        color: #2587ff;
      }
    }
  }
}
</style>
